import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

export default () => ({
	swiper: null,

	init() {
		this.$nextTick(() => {
			this.setupSwiper()
		})

		this.$cleanup = () => {
			this.swiper?.destroy()
		}
	},

	setupSwiper() {
		if (!this.$el) return

		this.swiper = new Swiper(this.$el, {
			touchEventsTarget: 'container',
			loop: true,
			touchRatio: 1,
			touchAngle: 45,
			grabCursor: true,

			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},

			// navigation: {
			// 	nextEl: '.swiper-button-next',
			// 	prevEl: '.swiper-button-prev',
			// },

			// scrollbar: {
			// 	el: '.swiper-scrollbar',
			// 	draggable: true,
			// },
		})
	},
})
